import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import MultiselectFilter from './MultiselectFilter';
import {
    getVipLayer,
} from 'actions';
import { useDispatch, useSelector } from "react-redux";

const VipScooterFilter = ({
    defaultSelected,
    onChange,
    isForcedOpen,
    disabled,
}) => {
    const dispatch = useDispatch();
    const vipList = useSelector(state => state.map.get('vips'));

    const vipOptions = vipList.toJS().map(({ service_ids, corporate_name }) => ({
                value: service_ids,
                text: corporate_name
            }));
    useEffect(() => {
        if (!vipOptions?.length) {
            dispatch(getVipLayer());
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);


    return (
        <MultiselectFilter
            title={ I18n.t('scooter.corporate') }
            options={ vipOptions }
            defaultSelected={ defaultSelected }
            onChange={ onChange }
            isForcedOpen={ isForcedOpen }
            disabled={ disabled }
        />
    );
};
VipScooterFilter.propTypes = {
    defaultSelected: PropTypes.arrayOf(PropTypes.array),
    onChange: PropTypes.func.isRequired,
    isForcedOpen: PropTypes.bool,
    disabled: PropTypes.bool,
};
VipScooterFilter.defaultProps = {
    defaultSelected: [],
    isForcedOpen: false,
    disabled: false,
};

const MemoizedFilter = React.memo(VipScooterFilter);

export default MemoizedFilter;

